<template>
  <span
    :class="cn(
      'tw:inline-flex tw:items-center tw:gap-1 tw:shrink-0 tw:tabular-nums tw:font-semibold',
      size === 'lg' ? 'tw:text-base' : 'tw:text-xs',
      {
        'tw:text-emerald-600': delta.direction === 'up',
        'tw:text-rose-600': delta.direction === 'down',
        'tw:text-zinc-500': delta.direction === 'flat',
      },
    )"
  >
    <!-- The figure is unsigned, so the arrow is the only thing saying which way the metric went. -->
    <component :is="icon" :size="size === 'lg' ? 20 : 14" role="img" :aria-label="meaning" />
    {{ delta.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { TrendingUp, TrendingDown, Minus } from '@lucide/vue';
import { cn } from '@/shadcn/lib/utils';
import type { MetricDelta } from './metrics';

const props = withDefaults(defineProps<{
  delta: MetricDelta
  size?: 'sm' | 'lg'
}>(), {
  size: 'sm',
});

const { t } = useI18n();

const icon = computed(() => ({ up: TrendingUp, down: TrendingDown, flat: Minus })[props.delta.direction]);

const meaning = computed(() => ({
  up: t('Increase'),
  down: t('Decrease'),
  flat: t('No change'),
})[props.delta.direction]);
</script>
